import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["display", "gap", "template", "children", "renderAs", "clientId"];
import React, { forwardRef, useMemo } from "react";
import { sizes } from "../../constants/spacing";
import { GridContainer } from "./styled/GridContainer";
export var Grid = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$display = _ref.display,
    display = _ref$display === void 0 ? "grid" : _ref$display,
    gap = _ref.gap,
    template = _ref.template,
    children = _ref.children,
    renderAs = _ref.renderAs,
    clientId = _ref.clientId,
    rest = _objectWithoutProperties(_ref, _excluded);
  var GridContainerRoot = useMemo(function () {
    return renderAs ? GridContainer.withComponent(renderAs) : GridContainer;
  }, [renderAs]);
  return /*#__PURE__*/React.createElement(GridContainerRoot, _extends({
    ref: ref,
    display: display,
    gap: gap === "none" ? 0 : sizes[gap],
    template: template,
    "data-client-id": clientId
  }, rest), children);
});
Grid.displayName = "Grid";
//# sourceMappingURL=Grid.js.map